import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import UserPostList from '@components/userPostList';
import FeedbackList from '@components/feedbackList';
import TabFilter from '@components/tabFilter';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import { copy } from '@utils/copy';
import { clearAllCookies, clearStorages } from '@utils/cookie';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
import TabNav  from '@components/tabNav';
import classNames from 'classnames';


interface RouteParams {
    code?: string;
}

interface UserPCPageProps extends BasePageProps, RouteComponentProps<RouteParams> {
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    userInfo?: any
    userMedalData?: any
    createFollowUser?: any
    followDelete?: any
    handleLoadMore: any
    navList?: any
    navClick?: Function
    navCurrentIndex?: any
    navCurrentType?: any
    postsList?: any   //评论列表
    openDialog?: any
    feedbackFilterIndex?: number
    feedbackFilterList?: any[]
    unreadNotificationsData?: any
    onFeedbackFilterChange?: (index: number) => void
    // friendList?: any // 关注/粉丝列表
    // friendType?: any    // 关注、粉丝类型
}
interface UserPCState { 
    loading: any
    error: any
    pageLoaded: any
    topicList?: any
    menuDropStatus: boolean
    
}
@inject('app', 'site', 'user', 'thread')
@observer
class UserPCPage extends BasePage<UserPCPageProps, UserPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        menuDropStatus: false,  // 退出登录下拉框
        // navList: [
        //     {name: '发帖', id: 0, type: '0'},
        //     // {name: '评论', id: 0, type: '1'},
        //     // {name: '点赞', id: 1, type: '2'},
        //     // {name: '收藏', id: 0, type: '3'},
        //     // {name: '勋章', id: 1, type: '4'},
        //     {name: '关注', id: 5, type: '5'},
        //     {name: '粉丝', id: 6, type: '6'},
        // ],  // tab切换列表
        // navCurrentIndex: 0, // 导航当前选中索引
        // navCurrentType: 0,  // 导航当前选中类型
        // followUserList: [], // 关注列表
        // fansUserList: [], // 粉丝列表
    };
    componentDidMount() {
        const { app, user, thread } = this.props;
        // if (user) {
        //     user.fetchUserInfo({ code: user?.userInfo?.code });
        // }
        // if (thread) {
        //     let params: any = {
        //         "page[number]": 1,
        //         "page[size]": 20
        //     }
        //     thread.getThreadList(params)
        // }
        super.componentDidMount();
    }

    // 跳转到帖子详情页
    // handleThreadClick = (id: string | number) => {
    //     this.props.history && this.props.history.push(`/threadDeatil/${id}`);
    // };

    // 点击复制
    onCopyClick = (data) => {
        copy(data);
        Toast.success({ content: '已复制社区号' });
    }

    // // 类型切换
    // navClick = (item:any) => {
    //     console.log(item, '当前')
    // }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // console.log('导航点击:', { item, index });
        
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 帖子列表
    renderThreadList = () => {
        const { user, handleLoadMore, navCurrentType } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['usersThreadsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'usersThreadsList' });
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    isSelf={isSelf}
                    showThreadStatus={navCurrentType == 0 ? true : false}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="usersThreadsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></ThreadList>
                    
                
            </div>
        )
    }

    // 评论列表
    renderPostList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['usersPostsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'usersPostsList' });
        // console.log(flatList, '用户评论列表111111111111');
        return (
            <div style={{ marginBottom: 16 }}>
                <UserPostList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="usersPostsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></UserPostList>

            </div>
        )
    }

    // 点赞列表
    renderLikesList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) {
            return null;
        }
        const list = user.listStore.lists['usersLikesList'];
        if (!list) {
            return null;
        }
        const flatList = user.listStore.getList({ namespace: 'usersLikesList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="usersLikesList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></ThreadList>
            </div>
        )
    }

    // 收藏列表
    renderFavoritesList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['usersFavoritesList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'usersFavoritesList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="usersFavoritesList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></ThreadList>
            </div>
        )
    }

    // 反馈列表
    renderFeedbackList = () => {
        const { thread, handleLoadMore, feedbackFilterIndex, feedbackFilterList, onFeedbackFilterChange } = this.props;
        if (!thread || !thread.listStore) return null;
        const flatList = thread.listStore.getList({ namespace: 'usersFeedbacksList' });
        const list = thread.listStore.lists['usersFeedbacksList'];

        const filterList = feedbackFilterList || [];

        return (
            <div style={{ marginBottom: 16 }}>
                <TabFilter
                    filterList={filterList}
                    currentIndex={feedbackFilterIndex || 0}
                    filterClick={(_item: any, index: number) => {
                        onFeedbackFilterChange && onFeedbackFilterChange(index);
                    }}
                    listStylesData={{background: '#E8E9EB'}}
                    boxStylesData={{marginBottom: '24px'}}
                />
                <FeedbackList
                    data={flatList}
                    loading={list?.loading || false}
                    hasMore={list?.hasMore ?? true}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 240px' }}
                    namespace="usersFeedbacksList"
                    onLoadMore={handleLoadMore}
                    listStore={thread.listStore}
                />
            </div>
        )
    }

    // 首页左侧侧内容
    readerLeft = () => {
        let { menuDropStatus} = this.state;
        const { user, userInfo, navList, navCurrentIndex, postsList, createFollowUser, followDelete, loading, hasMore, onLoadMore, openDialog, unreadNotificationsData } = this.props;
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        const displayNavList = isSelf ? navList : (navList || []).filter((item: any) => item?.namespace !== 'usersFavoritesList' && item?.namespace !== 'usersFeedbacksList');
        const displayNavCurrentIndex = displayNavList[navCurrentIndex] ? navCurrentIndex : 0;
        return (
            <div className={styles.leftContent}>
                <div className={styles.userDetail}>
                    {/* 用户头像背景 */}
                    {/* <div className={styles.userBgBox}>
                        <img src={userInfo?.backgroundUrl || `${BASE_IMG_URL}/common/user_bg4.png`} alt="头像背景" className={styles.userBg}/>
                        {isSelf && <div className={styles.userSettingBox}>
                            <img src={`${BASE_IMG_URL}/common/setting.png`} alt="设置" className={styles.settingIcon} onClick={() => {
                                this.setState({
                                    menuDropStatus: !menuDropStatus
                                })
                            }}/>
                            {menuDropStatus && <div className={styles.menuDropListBox}>
                                <div
                                    className={styles.menuDropItem}
                                    onClick={async () => {
                                        this.setState({ menuDropStatus: false });
                                       
                                        if (this.props.user) {
                                            await this.props.user.logoutRemote();
                                        }

                                        try {
                                            clearAllCookies();
                                            clearStorages();
                                        } catch (e) {
                                            // ignore
                                        }
                                        this.props.history && this.props.history.push(`/`);
                                    }}
                                >退出登录</div>
                            </div>}
                        </div>}
                    </div> */}

                    {/* 用户信息 */}
                    <div className={styles.userInfoBox}>
                        <div className={styles.avatarBox}>
                            <Avatar avatarUrl={userInfo?.avatarUrl || ''} size={100} titleMark={userInfo?.titleMark} level={userInfo?.level} userCode={userInfo?.code} officialSize={24} levelBadgeWidth={36} levelBadgeHeight={24}></Avatar>
                        </div>
                        
                        <div className={styles.userInfoDetail}>
                            <div className={styles.nickname}>
                                {userInfo?.nickname}
                                {userInfo?.gender === 2 && <img src={`${BASE_IMG_URL}/common/woman.png`} alt="性别" className={styles.gender}/>}
                                {userInfo?.gender === 1 && <img src={`${BASE_IMG_URL}/common/man.png`} alt="性别" className={styles.gender}/>}
                            </div>
                            <div className={styles.info}>
                                {userInfo?.lastPublishSource !== '' && <span className={styles.model}>{userInfo?.lastPublishSource}</span>}
                                <span className={styles.userId} onClick={() => this.onCopyClick(userInfo?.code)}>社区号  {userInfo?.code}</span>
                            </div>
                            {userInfo?.titleList?.length > 0 ? (
                                <div className={styles.userTags}>
                                    {userInfo?.titleList.slice(0, 5).map((tag) => <div className={classNames(styles.tag, tag.wear ? styles.tagActive : '')}>{tag.title_name}</div>)}
                                    <div className={styles.totalTags}>共{ userInfo?.titleList?.length }个头衔</div>
                                </div>
                            ) : (
                                <div className={styles.info3}>暂无头衔</div>
                            )}
                            <div className={styles.info}>{userInfo?.signature || '欢迎来到vivo社区，快来介绍下自己吧~'}</div>
                        </div>
                        <div className={styles.userRightBox}>
                            {!isSelf && <>
                                <div className={styles.message} onClick={()=>window.globalEnsureLogin(openDialog)}>私信</div>
                                {(userInfo?.follow === 0 || !userInfo?.follow) && <div className={styles.follow} onClick={()=>window.globalEnsureLogin(createFollowUser)}>关注</div>}
                                {(userInfo?.follow === 1 ||  userInfo?.follow === 2) && <div className={styles.followed} onClick={()=>window.globalEnsureLogin(followDelete)}>已关注</div>}
                            </>}
                            {isSelf && <>
                                <div className={styles.myPrivateBtnBox}>
                                    <div className={styles.myPrivateBtn} onClick={() => {
                                        this.props.history.push(`/privateMessage`)
                                    }}>我的私信</div>
                                    {unreadNotificationsData?.dialogNotifications > 0 && <div className={styles.privateNum}>{unreadNotificationsData?.dialogNotifications > 99 ? '99+' : unreadNotificationsData?.dialogNotifications}</div>}
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
                <TabNav navList={displayNavList} currentIndex={displayNavCurrentIndex} isAlignLeft={true} navClick={(item:any, index:any) => this.handleNavClick(item, index)} ></TabNav>
                <div className={styles.userTabContentBox}>
                    {/* 发帖列表 */}
                    {displayNavCurrentIndex == 0  && this.renderThreadList()}
                    {displayNavCurrentIndex == 1  && this.renderPostList()}
                    {displayNavCurrentIndex == 2  && this.renderLikesList()}
                    {isSelf && displayNavCurrentIndex == 3  && this.renderFavoritesList()}
                    {isSelf && displayNavCurrentIndex == 4  && this.renderFeedbackList()}
                    {/* 关注、粉丝 */}
                    {/* {(friendType == 1 || friendType == 2)  && <>
                        <UserList userList={friendList} emptyText={friendType == 1 ? '暂无关注': '暂无粉丝'} emptyBoxStyle={{ padding: '200px 0 500px' }} createFollowUserCallBack={createFollowUser} followDeleteCallBack={followDelete} loading={loading} hasMore={hasMore} onLoadMore={() => onLoadMore()}></UserList>
                    </>} */}
                   
                </div>
                
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        const { user, userInfo, createFollowUser, followDelete } = this.props;
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        // let isLogin = false;
        return (
            <div className={styles.rightContent}>
                
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 用户信息 */}
                <SidebarUserInfo isShowUserDetail={false} showOtherInfo={isSelf ? false : true} otherUserInfo={userInfo}></SidebarUserInfo>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>
                
            </div>
        );
    }

    render() {
        const { app } = this.props;

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={styles.wrapper}>
                {this.readerLeft()}
                {this.readerRight()} 
            </div>)
        }

    }
}

export default withRouter(UserPCPage);
